import {
    LOAD_POS_CHARGE_TYPES_SUCCESS } from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_POS_CHARGE_TYPES_SUCCESS:
            return action.payload;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/pos/ChargeTypesReducer.js